import React from "react"
import { Link } from "gatsby"

const Logo = props => (
  <div className="site-logo">
    <div>
      <img src={props.image} alt={props.title} style={{width: "100px"}} />
    </div>
    <Link to="/" />
  </div>
)

export default Logo
